import { mergeClassnames } from '@heathmont/moon-core-tw';
import Translate from '~/client/shared/i18n/Translate';
import useBadgeInfo from './useBadgeInfo';
import Tag from '@/external/components/Tag';

type Props = {
  status: TournamentStatus;
  won?: boolean;
};

const TournamentTypeBadge: FC<Props> = ({ status, won }) => {
  const { bgColor, translate } = useBadgeInfo({
    status,
    won,
  });
  return (
    <div className="grid h-max w-max gap-4">
      <Tag size="2xs" className={mergeClassnames('text-goten', bgColor)}>
        <Translate id={translate} />
      </Tag>
    </div>
  );
};

export default TournamentTypeBadge;
